import React, { useState, useEffect } from 'react'
import { useSlate, ReactEditor } from 'slate-react'
import { Transforms, Editor } from 'slate'
import clsx from 'clsx'

import { MARK_COLOR } from '../Canvas/TratoFormat/Marks'
import { ToolbarColorPicker } from './BackgroundColorButton'

export default function FontColorButton({ isDisabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentColor, setCurrentColor] = useState('#000')
  const [mark, setMark] = useState(null);
  const editor = useSlate()
  const { selection } = editor;

  useEffect(() => {
    try {
      const marks = Editor.marks(editor);
      if (marks) {
        const fontColor = marks?.[MARK_COLOR] ? marks[MARK_COLOR] : '#000'
      
        setCurrentColor(fontColor)
      } 
    } catch {
      setCurrentColor('#000')
    }
  }, [editor])

  const handleClick = (evt) => {
    evt.preventDefault();
    const { selection } = editor;

    setIsOpen(isOpen => !isOpen)
    setMark(selection);
  };

  const handleClose = (evt) => {
    evt.preventDefault()
    setIsOpen(false)
  };

  const handleChange = (color, e) => {
    try {
      e.preventDefault()
      e.stopPropagation();
      const { selection } = editor;
    
      if (selection) {
        // Transforms.select(editor, selection);
        // ReactEditor.focus(editor);
        if (color.hex === '#000000') {
          editor.removeMark(MARK_COLOR);
        } else {
          editor.addMark(MARK_COLOR, color.hex);
        }
        // setIsOpen(false)
        // Transforms.deselect(editor)
      } else {
        
        // updateAllTextNodes(editor, { [MARK_COLOR]: value }, {
        //   specialTextNodes: true
        // });        
      }
      setCurrentColor(color.hex)
    } catch (error) {
      console.error('FontColorError', error)
    }
  };

  return (
    <ToolbarColorPicker 
      icon="font"
      currentColor={currentColor}
      onClick={handleClick}
      onColorChange={handleChange}
      isDisabled={isDisabled}
    />
  )
}
